import React from 'react';

export default function AboutMe () {
    return (
        <div>
            <h1>About Me</h1>
        </div>
    );
};

